import * as React from 'react'
import { ShopifyNext } from '@dotdev/next-components'
import { GlobalProps } from 'types'
import * as Snippets from 'snippets'
import * as Helpers from 'helpers'

export class HeaderWishlist extends React.PureComponent<HeaderWishlist.Props, HeaderWishlist.State> {
  public static contextType = ShopifyNext.Context;

  private static kewl = new Helpers.ShopifyKewl({
    //@ts-ignore
    store: STOREFRONT_NAME,
    //@ts-ignore
    storeFrontKey: STOREFRONT_PASSWORD
  })

  public constructor(props) {
    super(props)
    this.state = {
      wishlist: [],
      isLoaded: false
    }
  }

  private getSwatchdata = async (products) => {
    const tags = []
    products.forEach(product => {
      // console.log('inside get swatch data - look for handle: ', product)
      tags.push(`colours:${[product.handle]}`)
    })
    const siblingsResults = await HeaderWishlist.kewl.productsBySwatchTags(tags)
    const newProducts = []
    products.forEach(product => {
      // console.log('product inside getSwatchData:', product)
      // console.log('product handle: ', product.handle)
      // console.log('product handle with replace: ', product.handle.replace(/\-/g, '_'))
      const underlinedHandle = product.handle.replace(/\-/g, '_')// eslint-disable-line no-useless-escape
      const siblingsQuantity = siblingsResults[underlinedHandle].length
      const filteredSiblings = siblingsResults[underlinedHandle].filter(sibling => sibling.handle !== product.handle)
      newProducts.push({ ...product, siblingsQuantity: siblingsQuantity, filteredSiblings: filteredSiblings })
    })
    // console.log('newProducts: ', newProducts)
    return newProducts
  }
  
  public fetchWishlistItems = () => {
    let _this = this
    let __wishlistedProducts = []
    window._swat?.fetch(function (products) {
      // console.log('products: ', products)
      products.forEach(function(product) {
        // console.log('product: ', product)
        let {du} = product
        fetch(du + '.json')
          .then(response => {
            if (!response.ok) {
              throw new Error(`Product not found: ${du}`)
            }
            return response.json()
          })
          .then(data => {
            if (data.product) {
              __wishlistedProducts.push(data.product)
            }
          })
          .catch(error => {
            console.warn(`Failed to fetch product: ${error.message}`)
          })
          .finally(() => {
            // Check if we've processed all products (whether successful or failed)
            if (products.length === products.length) {
              const items = __wishlistedProducts.filter(Boolean).map(item => {
                return item.product ? item.product : item
              })
              
              if (items.length > 0) {
                _this.getSwatchdata(items).then(wishlist => {
                  _this.setState({
                    wishlist: wishlist
                  })
                  document.dispatchEvent(new CustomEvent('swym:wishlist-fetched'))
                })
              } else {
                _this.setState({
                  wishlist: []
                })
              }
            }
          })
      })
    }, window._swat.EventTypes.addToWishlist)
  };
  
  public checkWishlistItem = (product: any) => {
    const { wishlist } = this.state
    // console.log("wishlist", wishlist);
    // console.log("product", product);
    if (wishlist.length === 0) {
      console.warn('wishlist is empty')
      return false
    }

    // check if item.id matches any of the res.epi
    const isRes = wishlist.some((r: any) => r.epi === product.id || r.empi === product.id)

    if (isRes) {
      // console.log('wishlist item found')
      return true
    }
    return false
  };
  
  public toggleWishlist = (product: any): void => {
    const _this = this
    
    const productData = {
      et: 4, // et 4 stands for wishlist event type
      epi: product.variants[0].id, // unique variant ID of the product.
      empi: product.id, // Product ID or master product ID
      du: `${window.location.origin}${product.url}`
    }
    
    if (this.checkWishlistItem(product)) {
      window._swat.removeFromWishList(
        productData,
        function (e: any) {
          console.log('wishlist item removed', e)
          _this.fetchWishlistItems()
        },
        function (e: any) {
          console.log('wishlist item failed', e)
        }
      )
    } else {
      window._swat.addToWishList(
        productData,
        function (e: any) {
          console.log('wishlist item added', e)
          _this.fetchWishlistItems()
        },
        function (e: any) {
          console.log('wishlist item failed', e)
        }
      )
    }
  } 
  
  public componentDidMount = () => {
    if (!window.SwymCallbacks) {
      window.SwymCallbacks = []
    }
    
    window.SwymCallbacks.push(this.fetchWishlistItems)
    
    document.addEventListener('swym:wishlist-updated', this.fetchWishlistItems)
  }

  public render(): JSX.Element {
    const { wishlist } = this.state
    const limit = this.props.data.customer ? (window.innerWidth > 900 ? 6 : 4) : (window.innerWidth > 900 ? 3 : 2)
    return (
      <div className={'w-full flex flex-col'}>
        <Snippets.Heading
          size={'h3'}
          tag={'h3'}
          className={'mb-3-2'}
        >
          Wishlist
        </Snippets.Heading>
        <div className={'mb-1-6 flex flex-wrap w-full'}>
          {wishlist && wishlist.length > 0 ? (
            wishlist.slice(0, limit).map((item: any, i) => {
              return (
                <div key={item.handle} className={`${this.props.data.customer ? (window.innerWidth > 900 ? 'w-1/6' : 'w-1/4') : (window.innerWidth > 900 ? 'w-1/3' : 'w-1/2')} pr-1-6`}>
                  <Snippets.CollectionProduct
                    collection={Helpers.check(this, 'this.props.data.collection') ? this.props.data.collection : null}
                    product={{ ...item, tags: item.tags_array, price: item.price_min, compare_at_price: item.compare_at_price_max }}
                    layout={'wishlist'}
                    list="Wishlist"
                    border
                    small
                    preventLazy
                    multiCurrencyTransform
                    isInWishlist={true}
                    toggleWishlist={this.toggleWishlist}
                    wishlist={this.state.wishlist}
                  />
                </div>
              )
            })
          ) : (
            <h2>Your Wishlist is empty!</h2>
          )}
        </div>
        {wishlist && wishlist.length > 0 && <Snippets.Button href={this.props.data.customer ? '/account?view=wishlist' : ShopifyNext.Wishlist.getURL()} title={'View all wishlist items'} colour={'blank'}>
          <Snippets.Heading size={'h5'} tag={'p'}>View All</Snippets.Heading>
        </Snippets.Button>}
      </div>
    )
  }
}

export namespace HeaderWishlist {
  export interface Props extends GlobalProps { }
  export interface State {
    wishlist: any,
    isLoaded: boolean
  }
}
